import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IQuestionHelpTextDetails } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'cake-sizes-section',
  templateUrl: './cake-sizes-section.component.html',
  styleUrls: ['./cake-sizes-section.component.scss']
})
export class CakeSizesSectionComponent {
  @Input() sizes: any[];
  @Input() active: boolean;
  @Input() activeSize: any;
  @Input() currency = 'kr';
  @Input() discount: number = 0;
  @Input() details: IQuestionHelpTextDetails;
  @Output() onSelect = new EventEmitter<any>();

  public isActiveSize(size) {
    if (!this.activeSize) {
      return false;
    }

    return this.activeSize.details.id === size.details.id;
  }
}
